import React from 'react';
import 'jquery/dist/jquery.min.js';
import "datatables.net-dt/js/dataTables.dataTables"
import "datatables.net-dt/css/jquery.dataTables.min.css"
import $ from 'jquery'; 
import './Table.css';
import {Link} from "react-router-dom";

class Table extends React.Component {
	state = {
        dataset: []
    }

  componentDidMount() {
	  fetch('http://localhost:8090/api/orders/')
        .then((response) => response.json())
        .then(data => {
            this.setState({ dataset: data });
        });
	 
 
 }
 componentDidUpdate() {
    //initialize datatable
    $(document).ready(function () {
        $('#example').DataTable();
    });
  }
  render(){
    //Datatable HTML
  return (
      <div className="container my-4">
	  <div className="table table-main">
          <table id="example" class="table table-bordered">
            <thead>
                <tr>
                    <th>WORKSHOP_NO</th>
<th>MACHINE_CODE</th>
<th>MACHINE_NAME</th>
<th>MACGROUP_CODE</th>
<th>MSUBGROUP_CODE</th>
<th>CRITICAL</th>
<th>SPEC1</th>
<th>SPEC2</th>
<th>SPEC3</th>
<th>SPEC4</th>
<th>LOCATION</th>
<th>USAGE</th>
<th>CC_CODE</th>
<th>MANUFACTURER</th>
<th>MACHINE_TYPE</th>
<th>SR_N0</th>
<th>GRN_NO</th>
<th>PO_NO</th>
<th>INSTALLATION_DATE</th>
<th>PO_DATE</th>
<th>COMMISSIONING_DATE</th>
<th>PURCHASE_COST</th>
<th>LIFE_SPAN</th>
<th>WARRANTY_FROM_DATE</th>
<th>WARRANTY_TO_DATE</th>
<th>SAFETY_MEAS1</th>
<th>SAFETY_MEAS2</th>
<th>SAFETY_MEAS3</th>
<th>SAFETY_MEAS4</th>
<th>CONTRACT_TO</th>
<th>AMC_EXPIRY_DATE</th>
<th>KW_LOAD</th>
<th>TRANSFERED_TO_WORKSHOP</th>
<th>TEXT_INSTALLATION_DATE</th>
<th>TEXT_COMMISIONING_DATE</th>
<th>TEXT_WARRENTY_FROM_DATE</th>
<th>TEXT_WARRENTY_TO_DATE</th>
<th>TEXT_PO_DATE</th>
<th>TEXT_AMC_EXPIARY_DATE</th>
<th>OBSERVATION1</th>
<th>OBSERVATION2</th>
<th>OBSERVATION3</th>
<th>OBSERVATION4</th>
<th>OPTION1</th>
<th>CATALOGUE_NO</th>
<th>CPMCK_VALUES</th>
<th>VIBRATION_VALUE</th>
<th>ACTIVE_INACTIVE</th>
<th>Cmk_values</th>
<th>MAC_TYPE</th>
<th>STATUS</th>
<th>PerDownTimeCost</th>
<th>AssetUsedForProd</th>
<th>PM_DoneOnAsset</th>
<th>DTMFMachineCode</th>
<th>RESPONSIBILITY</th>
<th>USER_ID</th>
<th>DownTimeFactor</th>
<th>AssetCode</th>
<th>UtilityEquipment</th>
<th>MACHINE_DEACTIVATION_DATE</th>
<th>InsertionDate</th>
<th>ModifiedDate</th>
<th>InsertedBy</th>
<th>ModifiedBy</th>
                </tr>
            </thead>
            <tbody>
			{this.state.dataset.map((machine,i) => (
					<tr key={i}>
			<td>{machine.WORKSHOP_NO}</td>
<td><Link to={`/home/?id=${machine.MACHINE_CODE}`}>{machine.MACHINE_CODE}</Link></td>
<td>{machine.MACHINE_NAME}</td>
<td>{machine.MACGROUP_CODE}</td>
<td>{machine.MSUBGROUP_CODE}</td>
<td>{machine.CRITICAL}</td>
<td>{machine.SPEC1}</td>
<td>{machine.SPEC2}</td>
<td>{machine.SPEC3}</td>
<td>{machine.SPEC4}</td>
<td>{machine.LOCATION}</td>
<td>{machine.USAGE}</td>
<td>{machine.CC_CODE}</td>
<td>{machine.MANUFACTURER}</td>
<td>{machine.MACHINE_TYPE}</td>
<td>{machine.SR_N0}</td>
<td>{machine.GRN_NO}</td>
<td>{machine.PO_NO}</td>
<td>{machine.INSTALLATION_DATE}</td>
<td>{machine.PO_DATE}</td>
<td>{machine.COMMISSIONING_DATE}</td>
<td>{machine.PURCHASE_COST}</td>
<td>{machine.LIFE_SPAN}</td>
<td>{machine.WARRANTY_FROM_DATE}</td>
<td>{machine.WARRANTY_TO_DATE}</td>
<td>{machine.SAFETY_MEAS1}</td>
<td>{machine.SAFETY_MEAS2}</td>
<td>{machine.SAFETY_MEAS3}</td>
<td>{machine.SAFETY_MEAS4}</td>
<td>{machine.CONTRACT_TO}</td>
<td>{machine.AMC_EXPIRY_DATE}</td>
<td>{machine.KW_LOAD}</td>
<td>{machine.TRANSFERED_TO_WORKSHOP}</td>
<td>{machine.TEXT_INSTALLATION_DATE}</td>
<td>{machine.TEXT_COMMISIONING_DATE}</td>
<td>{machine.TEXT_WARRENTY_FROM_DATE}</td>
<td>{machine.TEXT_WARRENTY_TO_DATE}</td>
<td>{machine.TEXT_PO_DATE}</td>
<td>{machine.TEXT_AMC_EXPIARY_DATE}</td>
<td>{machine.OBSERVATION1}</td>
<td>{machine.OBSERVATION2}</td>
<td>{machine.OBSERVATION3}</td>
<td>{machine.OBSERVATION4}</td>
<td>{machine.OPTION1}</td>
<td>{machine.CATALOGUE_NO}</td>
<td>{machine.CPMCK_VALUES}</td>
<td>{machine.VIBRATION_VALUE}</td>
<td>{machine.ACTIVE_INACTIVE}</td>
<td>{machine.Cmk_values}</td>
<td>{machine.MAC_TYPE}</td>
<td>{machine.STATUS}</td>
<td>{machine.PerDownTimeCost}</td>
<td>{machine.AssetUsedForProd}</td>
<td>{machine.PM_DoneOnAsset}</td>
<td>{machine.DTMFMachineCode}</td>
<td>{machine.RESPONSIBILITY}</td>
<td>{machine.USER_ID}</td>
<td>{machine.DownTimeFactor}</td>
<td>{machine.AssetCode}</td>
<td>{machine.UtilityEquipment}</td>
<td>{machine.MACHINE_DEACTIVATION_DATE}</td>
<td>{machine.InsertionDate}</td>
<td>{machine.ModifiedDate}</td>
<td>{machine.InsertedBy}</td>
<td>{machine.ModifiedBy}</td>
                </tr>
                ))}
				
            </tbody>
            
        </table>
		</div>
          
        </div>
  );

}

}
export default Table;
